"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArticlesPage = void 0;
var react_1 = __importStar(require("react"));
var doshx_controls_web_1 = require("doshx_controls_web");
var page_path_1 = require("../components/page_path");
var react_router_dom_1 = require("react-router-dom");
var get_articles_1 = require("../../../api/calls/news/get_articles");
var logo1_png_1 = __importDefault(require("../../../assets/logos/logo1.png"));
var ArticlesPage = function () {
    var _a, _b;
    var _c = (0, react_1.useState)(), publication = _c[0], setPublication = _c[1];
    var params = (0, react_router_dom_1.useParams)();
    var publication_id = params.publication_id;
    var _d = (0, react_1.useState)([]), articles = _d[0], setArticles = _d[1];
    var _e = (0, react_1.useState)(true), isLoading = _e[0], setIsLoading = _e[1];
    var navigate = (0, react_router_dom_1.useNavigate)();
    (0, react_1.useEffect)(function () {
        (0, get_articles_1.getArticles)({
            publication: publication_id,
        }).then(function (response) {
            var _a, _b;
            if (response.success) {
                var tempData_1 = [];
                (_a = response === null || response === void 0 ? void 0 : response.content) === null || _a === void 0 ? void 0 : _a.articles.forEach(function (doc) {
                    var article = doc.data();
                    tempData_1.push(__assign({ uid: doc.id }, article));
                });
                setIsLoading(false);
                // Sorting the array based on datePublished
                tempData_1.sort(function (a, b) { var _a, _b; return ((_a = b.pubDate) === null || _a === void 0 ? void 0 : _a.seconds) - ((_b = a.pubDate) === null || _b === void 0 ? void 0 : _b.seconds); });
                setArticles(tempData_1);
                setPublication((_b = response === null || response === void 0 ? void 0 : response.content) === null || _b === void 0 ? void 0 : _b.publication.data());
            }
        });
        //
    }, []);
    return (react_1.default.createElement("div", { className: "" },
        react_1.default.createElement(doshx_controls_web_1.ScreenContainerControl, { className: "flex flex-col gap-4" },
            react_1.default.createElement(page_path_1.PagePath, { path: [
                    {
                        page: "/",
                        title: "Home",
                    },
                    {
                        page: "/publications",
                        title: "Publications",
                    },
                    {
                        title: "".concat((_a = publication === null || publication === void 0 ? void 0 : publication.name) !== null && _a !== void 0 ? _a : "..."),
                        active: true,
                    },
                ] }),
            react_1.default.createElement("div", { className: "flex flex-row gap-4 justify-center" },
                react_1.default.createElement("img", { className: "h-20", src: "".concat((_b = publication === null || publication === void 0 ? void 0 : publication.image) !== null && _b !== void 0 ? _b : logo1_png_1.default), alt: "Publication" })),
            isLoading ? (react_1.default.createElement(doshx_controls_web_1.ShimmerBoxControl, null)) : (articles.map(function (article, index) {
                var _a;
                return (react_1.default.createElement("div", { onClick: function () {
                        navigate("/article/".concat(publication_id, "/").concat(article.uid));
                    }, key: index },
                    react_1.default.createElement("div", { className: "shadow hover:shadow-lg transition-shadow cursor-pointer p-2 rounded-md" },
                        react_1.default.createElement("div", { className: "flex flex-col md:flex-row gap-2 justify-between items-center" },
                            react_1.default.createElement(doshx_controls_web_1.LabelControl, { className: "cursor-pointer text-center", label: article === null || article === void 0 ? void 0 : article.title, size: "medium", textColor: "text-secondary" }),
                            react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "".concat(doshx_controls_web_1.Utilities.formatDateTime(((_a = article === null || article === void 0 ? void 0 : article.pubDate) === null || _a === void 0 ? void 0 : _a.seconds) * 1000, "MMMM DD, YYYY h:mm a")), size: "small" })))));
            })))));
};
exports.ArticlesPage = ArticlesPage;
